import { render, staticRenderFns } from "./EditAttendancePoint.vue?vue&type=template&id=f179a526"
import script from "./EditAttendancePoint.vue?vue&type=script&lang=js"
export * from "./EditAttendancePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports